import React , { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { getDrilldownLabel } from './Utils';
import Helpable from '../Helpable';

class Drilldown extends Component {
  constructor(props) {
    super(props);

    this.breadcrumbNavigationHandler = this.breadcrumbNavigationHandler.bind(this);
  //  this.getDrilldownLabel = this.getDrilldownLabel.bind(this);

  }

  breadcrumbNavigationHandler(evt) {

    const {params} = this.props.routeParams;

    let graphContext = this.props.paramContext;

    // Devo costruire un path che mi permette (tramite history del router) di ricaricare
    // un grafico già visualizzato

    let path = "/"+graphContext.kind+"/"+graphContext.operation;
    let continuation="";

    // Indice nella barra navigazione
    // 0: tutti gli anni,
    // 1: Anno specifico -> Visualizzare grafico relativo a tutti i mesi dell'anno selezionato
    // 2: Mese specifico -> Visualizzare grafico relativo a tutti i giorni del mese selezionato
    // 3: Giorno specifico -> Visualizzare grafico relativo a tutte le ore del giorno giorno selezionato

    let paramDepth =  ["", params.year, params.month, params.day];

    for (let i=1;i<=evt.index;i++) {
      continuation+="/"+paramDepth[i];
    }

    path+=continuation;

    this.context.router.push({pathname:path, query:this.props.location.query});
  }



  render() {
    const {formatMessage} = this.props.intl;
    const {params} = this.props.routeParams;

    let breadcrumbLabel = null;
    var drillDownList = [];
    let drilldownhistory = [];

    let currDepth = this.props.currentDrillDown;

    let date = null;

    if ( params.year ) {
      date = (new Date(params.year, params.month ? (params.month-1) : 0, params.day ? params.day : 1)).getTime();
    }

    // Creo array per breadcrumb
    for (var i=0;i<=currDepth; i++) {

      breadcrumbLabel = getDrilldownLabel(i,date, this.props.intl);

      drillDownList.push(breadcrumbLabel);
    }



  let hasDrilldown = false;
  if (drillDownList.length >0 && this.props.toggleDetailsInfo.isClickable ) {
    hasDrilldown = true;

    let lenValue = drillDownList.length-1;

    let drillDownStyle = {
      fontSize:'10pt',
      textTransform:'capitalize',
      textDecoration: 'none',
      cursor: 'pointer'
    }

    let drillDownStyleActive = {
      textTransform:drillDownStyle.textTransform,
      fontSize:drillDownStyle.fontSize,
      fontWeight:'700'
    };

    drillDownList.forEach(function(drilldown,i) {

    if (i<lenValue) {
        drilldownhistory.push (
          <li key={i}>
            <a key={i} style={drillDownStyle} onClick={this.breadcrumbNavigationHandler.bind(this, {action:'navigation', drilldown:drilldown, index:i})}>
              {drilldown}
            </a>
          </li>
        );
      } else {

        drilldownhistory.push(
          <li key={i} className="active">
            <span style={drillDownStyleActive} key={i}>{drilldown}</span>
          </li>
        );
      }
   }.bind(this));

   }


  return (
     <Helpable bind="drilldownId" attachment="middle left" guideRef="toolbar.drilldown.guide">
    <div id="drilldownId" className="form-group" style={{borderRight:'none', paddingTop:'2px'}} >
      <span style={{fontSize:'11pt', fontWeight:300}}>Drilldown: </span>
        { hasDrilldown ?
          <ol className="breadcrumb" style={{paddingLeft:'5px', paddingBottom:'0px', paddingTop:'0px', marginBottom:'0px', display: 'inline'}}>
           {drilldownhistory}
         </ol>
         :
         <span style={{fontSize:'11pt', fontWeight:600}}>{formatMessage({id:'noDrilldown'})}</span>
       }
    </div>
    </Helpable>
   )

  }
}

Drilldown.contextTypes = {
  router: PropTypes.object.isRequired
};

export default injectIntl(Drilldown);



// WEBPACK FOOTER //
// ./src/components/ChartPanel/Drilldown.js